<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>{{ nama }}</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                {{ id_informasi_download != null ? 'Edit' : 'Tambah' }} {{ nama }}
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal" v-on:submit.prevent="onSubmit">
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="judul">Judul</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="judul" type="text" v-model="content.judul"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="icon">File</label>
                                    </div>
                                    <div class="col-lg-2" v-if="content.file != null">
                                        <a class="btn btn-sm btn-info" target="_blank" v-bind:href="content.file"><i class="fa fa-paperclip"></i> File</a>
                                    </div>
                                    <div class="col-lg-8 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <input id="icon" class="form-control" type="file" name="icon" @change="handleFile($event)" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                        <button v-if="id_informasi_download != null" @click="update" type="button" class="btn btn-warning waves-effect waves-button" v-bind:disabled="isLoading" v-waves.button><i v-if="isLoading" class="fa fa-spin fa-spinner"></i><i v-if="!isLoading" class="material-icons">save</i> Edit</button>
                                        <button v-else @click="save" type="button" class="btn btn-primary waves-effect waves-button" v-bind:disabled="isLoading" v-waves.button><i v-if="isLoading" class="fa fa-spin fa-spinner"></i><i v-if="!isLoading" class="material-icons">save</i> Simpan</button>
                                        <button @click="$router.go(-1)" type="button" class="btn btn-danger waves-effect waves-button" v-waves.button><i class="material-icons">cancel</i> Batal</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import Ckeditor from 'vue-ckeditor2'
  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'

  export default {
    components: {FormLine, Ckeditor},
    name: 'ListNarasumber',
    data: function () {
      return {
        config: {
          toolbar: [
            { name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
            { name: 'morestuff', items: ['NumberedList', 'BulletedList'] },

            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] },
            { name: 'colors', items: ['TextColor'] },
            { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] },
            '/',
            { name: 'document', items: ['Source'] }
          ],
          height: 300
        },
        content: {
          judul: ''
        },
        file: '',
        id_informasi_download: '',
        nama: '',
        tipe: '',
        link: '',
        isLoading: false
      }
    },
    methods: {
      save () {
        this.isLoading = true
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        var form = new FormData()
        form.append('file', this.file)
        form.append('json', JSON.stringify(this.content))
        api.post('/informasi_download', form).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/informasi/' + this.link)
            this.$toastr.s('Tambah data berhasil')
          } else {
            var msg = 'Tambah data gagal'
            if (result.data.message !== '') msg = result.data.message
            this.$toastr.e(msg)
          }
          this.isLoading = false
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      },
      update () {
        this.isLoading = true
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        var form = new FormData()
        form.append('file', this.file)
        form.append('json', JSON.stringify(this.content))
        api.post('/informasi_download/' + this.id_informasi_download, form).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/informasi/' + this.link)
            this.$toastr.s('Ubah data berhasil')
          }
          this.isLoading = false
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      },
      getDetail () {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/informasi_download/' + this.id_informasi_download).then((result) => {
          this.content = result.data
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
          this.$router.replace('/main/informasi/' + this.link)
        })
      },
      handleFile (file) {
        this.file = file.target.files[0]
      },
      onSubmit () {
        if (this.id_informasi_download != null) this.update()
        else this.save()
      },
      checkRoute (route) {
        console.log(route.name)
        if (route.name === 'TambahPerkembangan' || route.name === 'EditPerkembangan') {
          this.content.tipe = 1
          this.link = 'perkembangan'
          this.nama = 'Laporan Perkembangan'
        }
        if (route.name === 'TambahTahunan' || route.name === 'EditTahunan') {
          this.content.tipe = 2
          this.link = 'tahunan'
          this.nama = 'Laporan Keuangan'
        }
        if (route.name === 'TambahLowongan' || route.name === 'EditLowongan') {
          this.content.tipe = 3
          this.link = 'lowongan'
          this.nama = 'Laporan Lowongan'
        }
      }
    },
    mounted () {
      this.checkRoute(this.$route)
      this.id_informasi_download = this.$route.params.id
      if (this.id_informasi_download != null) {
        this.getDetail()
      }
    },
    '$route' (to, from) {
      this.checkRoute(to)
      this.getData()
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/Informasi/Download/FormDownload.vue?de00d8b6